const tab_sections = {
    overview: 'نمای کلی',
    authentication: 'احراز هویت',
    authorization: 'مجوزدهی',
    users: 'کاربران',
    developer: 'توسعه‌دهنده',
    tenant: 'مستأجر',
};
export default Object.freeze(tab_sections);
